/* Univers Maroc: mirror Dawn's live variant price above the gallery on mobile. */
(() => {
  const init = (root) => {
    if (!root || !root.classList.contains('um-pdp-enabled') || root.dataset.umPriceReady) return;
    const source = root.querySelector('[id^="price-"]');
    const target = root.querySelector('[id^="um-mobile-price-"]');
    if (!source || !target) return;
    root.dataset.umPriceReady = '1';
    const sync = () => {
      target.innerHTML = source.innerHTML;
      target.classList.toggle('hidden', source.classList.contains('hidden'));
    };
    new MutationObserver(sync).observe(source, { childList: true, attributes: true, attributeFilter: ['class'] });
  };
  document.addEventListener('product-info:loaded', (e) => init(e.target));
  const scan = () => document.querySelectorAll('product-info.um-pdp-enabled').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan, { once: true });
  else scan();
})();
